<template>
  <div class="container-box">
    <el-table :data="invoiceInfo" border size="mini" max-height="400px">
      <el-table-column
        label="开票状态"
        align="center"
        prop="invoiceStatus"
        fixed="left"
        width="100"
      >
        <template slot-scope="scope">
          <el-tooltip
            :content="scope.row.invoiceStatus"
            placement="top"
            :disabled="!scope.row.invoiceStatus"
          >
            <div class="text-ellipsis-2 copyable" @click="copyToClipboard(scope.row.invoiceStatus)">
              {{ scope.row.invoiceStatus }}
            </div>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="发票类型" align="center" prop="invoiceType" width="100">
        <template slot-scope="scope">
          <el-tooltip
            :content="scope.row.invoiceType"
            placement="top"
            :disabled="!scope.row.invoiceType"
          >
            <div class="text-ellipsis-2 copyable" @click="copyToClipboard(scope.row.invoiceType)">
              {{ scope.row.invoiceType }}
            </div>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="发票号码" align="center" prop="invoiceNumber" width="100">
        <template slot-scope="scope">
          <el-tooltip
            :content="scope.row.invoiceNumber"
            placement="top"
            :disabled="!scope.row.invoiceNumber"
          >
            <div class="text-ellipsis-2 copyable" @click="copyToClipboard(scope.row.invoiceNumber)">
              {{ scope.row.invoiceNumber }}
            </div>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="发票代码" align="center" prop="invoiceCode" width="100">
        <template slot-scope="scope">
          <el-tooltip
            :content="scope.row.invoiceCode"
            placement="top"
            :disabled="!scope.row.invoiceCode"
          >
            <div class="text-ellipsis-2 copyable" @click="copyToClipboard(scope.row.invoiceCode)">
              {{ scope.row.invoiceCode }}
            </div>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="发票抬头" align="center" prop="invoiceTitle" width="100">
        <template slot-scope="scope">
          <el-tooltip
            :content="scope.row.invoiceTitle"
            placement="top"
            :disabled="!scope.row.invoiceTitle"
          >
            <div class="text-ellipsis-2 copyable" @click="copyToClipboard(scope.row.invoiceTitle)">
              {{ scope.row.invoiceTitle }}
            </div>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="税号" align="center" prop="taxNumber">
        <template slot-scope="scope">
          <el-tooltip
            :content="scope.row.taxNumber"
            placement="top"
            :disabled="!scope.row.taxNumber"
          >
            <div class="text-ellipsis-2 copyable" @click="copyToClipboard(scope.row.taxNumber)">
              {{ scope.row.taxNumber }}
            </div>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="金额" align="center" prop="amount">
        <template slot-scope="scope">
          <el-tooltip :content="scope.row.amount" placement="top" :disabled="!scope.row.amount">
            <div class="text-ellipsis-2 copyable" @click="copyToClipboard(scope.row.amount)">
              {{ scope.row.amount }}
            </div>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="备注" align="center" prop="remark">
        <template slot-scope="scope">
          <el-tooltip :content="scope.row.remark" placement="top" :disabled="!scope.row.remark">
            <div class="text-ellipsis-2 copyable" @click="copyToClipboard(scope.row.remark)">
              {{ scope.row.remark }}
            </div>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="邮箱/手机号" align="center" prop="emailAndPhoneNumber" width="100">
        <template slot-scope="scope">
          <el-tooltip
            :content="scope.row.emailAndPhoneNumber"
            placement="top"
            :disabled="!scope.row.emailAndPhoneNumber"
          >
            <div
              class="text-ellipsis-2 copyable"
              @click="copyToClipboard(scope.row.emailAndPhoneNumber)"
            >
              {{ scope.row.emailAndPhoneNumber }}
            </div>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="座位号" align="center" prop="seatNumber">
        <template slot-scope="scope">
          <el-tooltip
            :content="scope.row.seatNumber"
            placement="top"
            :disabled="!scope.row.seatNumber"
          >
            <div class="text-ellipsis-2 copyable" @click="copyToClipboard(scope.row.seatNumber)">
              {{ scope.row.seatNumber }}
            </div>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="反馈信息" align="center" prop="feedbackInfo">
        <template slot-scope="scope">
          <el-tooltip
            :content="scope.row.feedbackInfo"
            placement="top"
            :disabled="!scope.row.feedbackInfo"
          >
            <div class="text-ellipsis-2 copyable" @click="copyToClipboard(scope.row.feedbackInfo)">
              {{ scope.row.feedbackInfo }}
            </div>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="申请时间" align="center" prop="applyTime">
        <template slot-scope="scope">
          <el-tooltip
            :content="scope.row.applyTime"
            placement="top"
            :disabled="!scope.row.applyTime"
          >
            <div class="text-ellipsis-2 copyable" @click="copyToClipboard(scope.row.applyTime)">
              {{ scope.row.applyTime }}
            </div>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" fixed="right" width="200">
        <template slot-scope="scope">
          <div
            v-show="
              isRedHandle & (scope.row.state === 1) & (scope.row.serialNo === currentSerialNo)
            "
          >
            <i class="el-icon-loading"></i>
            <span style="margin-left: 5px">红冲中~</span>
          </div>
          <el-button
            v-show="(scope.row.state === 1) & (isRedHandle === false)"
            type="text"
            size="small"
            @click="handleResetRed(scope.row.serialNo)"
            v-has-permi="['order_intercity_offset']"
          >
            红冲
          </el-button>
          <el-button
            v-show="scope.row.invoiceUrl"
            type="text"
            size="small"
            @click="previewInvoice(scope.row.invoiceUrl)"
          >
            预览发票
          </el-button>
          <el-button
            v-show="scope.row.state === 1"
            type="text"
            size="small"
            @click="getInvoiceItinerary(scope.row.serialNo)"
            :loading="itineraryLoading"
          >
            预览行程单
          </el-button>
          <el-button
            v-show="scope.row.state === 1"
            type="text"
            size="small"
            @click="onSendInvoice(scope.row)"
            :loading="sendLoading"
          >
            重发邮件
          </el-button>

          <el-button
            type="text"
            size="small"
            @click="confirmAction(scope.row, 1)"
            v-has-permi="['order_invoice_confirm']"
            v-show="scope.row.emailInvoiceFlag && scope.row.invoiceTypeCode === 1"
          >
            开票确认
          </el-button>

          <el-button
            type="text"
            size="small"
            @click="confirmAction(scope.row, 2)"
            v-show="scope.row.emailInvoiceFlag && scope.row.invoiceTypeCode === 2"
          >
            红冲确认
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      title="行程单"
      :visible.sync="itineraryShow"
      :append-to-body="true"
      width="50%"
      @close="close"
    >
      <InvoiceItinerary v-if="itineraryShow" :item="itineraryInfo" />
    </el-dialog>
    <el-dialog
      title="重新发送发票、行程单"
      :close-on-click-modal="false"
      :visible="sendShow"
      :append-to-body="true"
      width="35%"
      @close="closeSend"
      center
    >
      <div class="flex-col flex-center">
        <div class="margin-bottom-10">请填写乘客手机号或电子邮箱，手机号无法发送行程单</div>
        <el-form
          label-position="right"
          ref="modifyFormRef"
          :model="form"
          label-width="auto"
          size="mini"
          :rules="rules"
        >
          <el-form-item label="收信方式：" prop="type">
            <el-radio-group v-model="form.type" @input="typeChange">
              <el-radio :label="1">邮箱</el-radio>
              <el-radio :label="2">手机号</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="是否发送行程单：" v-if="form.type === 1">
            <el-radio-group v-model="form.isSendItinerary">
              <el-radio :label="true">发送</el-radio>
              <el-radio :label="false">不发送</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="form.type === 1" label="邮箱：" prop="userEmail">
            <el-input
              type="text"
              placeholder="请输入邮箱"
              v-model.trim="form.userEmail"
              style="width: 250px"
            />
          </el-form-item>
          <el-form-item v-else label="手机号：" prop="phone">
            <el-input
              type="text"
              placeholder="请输入手机号"
              v-model.trim="form.phone"
              style="width: 250px"
            />
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" type="danger" @click="closeSend">取消</el-button>
        <el-button type="primary" size="small" @click="submit" :loading="sendLoading">
          提 交
        </el-button>
      </div>
    </el-dialog>

    <!-- 订单开票二次确认弹窗 -->
    <InvoiceAction ref="invoiceAction" @refresh="$emit('refresh')" />
  </div>
</template>

<script>
  import { invoiceItinerary, sendInvoice } from '@/api/invoice'
  import InvoiceItinerary from '@/components/InvoiceItinerary'
  import InvoiceAction from './invoiceAction.vue'
  import dayjs from 'dayjs'
  export default {
    name: 'invoiceDetailInfo',
    props: {
      info: {},
      isRedHandle: {
        type: Boolean
      },
      currentSerialNo: {
        type: String
      }
    },
    components: {
      InvoiceItinerary,
      InvoiceAction
    },
    data() {
      /* 手机号 */
      const isphoneNumber = (rule, value, callback) => {
        if (!value) {
          return new Error('请输入电话号码')
        } else {
          const reg = /^1[3|4|5|7|8][0-9]\d{8}$/
          const isPhone = reg.test(value)
          value = Number(value) // 转换为数字
          if (typeof value === 'number' && !isNaN(value)) {
            // 判断是否为数字
            value = value.toString() // 转换成字符串
            if (value.length < 0 || value.length > 12 || !isPhone) {
              // 判断是否为11位手机号
              callback(new Error('手机号码格式如:138xxxx8754'))
            } else {
              callback()
            }
          } else {
            callback(new Error('请输入电话号码'))
          }
        }
      }
      /* 邮箱 */
      const isEmail = (rule, value, callback) => {
        if (!value) {
          callback()
        } else {
          const reg =
            /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/
          const email = reg.test(value)
          if (!email) {
            callback(new Error('邮箱格式如:admin@163.com'))
          } else {
            callback()
          }
        }
      }
      return {
        sendLoading: false,
        itineraryLoading: false,
        itineraryInfo: {},
        itineraryShow: false,
        sendShow: false,
        /* 校验规则 */
        rules: {
          phone: [
            { required: true, message: '请输入手机号码', trigger: 'blur' },
            { validator: isphoneNumber, trigger: 'blur' }
          ],
          userEmail: [
            { required: true, message: '请输入邮箱', trigger: 'blur' },
            { validator: isEmail, trigger: 'blur' }
          ]
        },
        form: {
          type: 1,
          mobil: '',
          userEmail: '',
          isSendItinerary: true
        },
        modifyFormRef: null,
        serialNo: ''
      }
    },
    computed: {
      invoiceInfo() {
        // 使用dayjs对props.info中的invoiceInfo按applyTime字段排序，最新的排在前面

        const data = this.info.invoiceInfo || []

        return data.sort((a, b) => {
          // 如果applyTime存在，使用dayjs进行时间比较
          if (a.applyTime && b.applyTime) {
            return dayjs(b.applyTime).valueOf() - dayjs(a.applyTime).valueOf()
          }

          // 处理applyTime不存在的情况
          if (!a.applyTime && !b.applyTime) return 0
          if (!a.applyTime) return 1
          if (!b.applyTime) return -1

          return 0
        })
      }
    },
    methods: {
      handleResetRed(serialNo) {
        this.$loading({})
        this.$emit('handleResetRed', serialNo)
      },
      previewInvoice(url) {
        // location.href = url
        window.open(url, '_blank')
      },
      async getInvoiceItinerary(serialNo) {
        this.itineraryLoading = true
        const { data, code } = await invoiceItinerary(serialNo)
        if (code === 0) {
          this.itineraryInfo = data
          this.itineraryShow = true
        }
        this.itineraryLoading = false
      },
      async onSendInvoice(item) {
        this.sendShow = true
        this.serialNo = item.serialNo
      },
      close() {
        this.itineraryInfo = {}
        this.itineraryShow = false
      },
      typeChange() {
        this.form.mobil = ''
        this.form.userEmail = ''
        this.$refs.modifyFormRef.clearValidate()
      },
      async submit() {
        this.$refs.modifyFormRef.validate(async (vaild) => {
          if (vaild) {
            const { type, phone, userEmail, isSendItinerary } = this.form
            const params = {
              serialNo: this.serialNo
            }
            if (type === 1) {
              params.userEmail = userEmail
              params.isSendItinerary = isSendItinerary
            } else {
              params.phone = phone
            }
            this.sendLoading = true
            const { code } = await sendInvoice(params)
            if (code === 0) {
              this.$message.success('发送成功！')
              this.closeSend()
            }
            this.sendLoading = false
          } else {
            return false
          }
        })
      },
      closeSend() {
        this.sendShow = false
        this.form = {
          type: 1,
          mobil: '',
          userEmail: '',
          isSendItinerary: true
        }
        this.serialNo = ''
      },
      async copyToClipboard(text) {
        if (!text) return

        try {
          // 使用现代 Clipboard API
          if (navigator.clipboard && window.isSecureContext) {
            await navigator.clipboard.writeText(text)
          } else {
            // 降级方案：使用传统的复制方法
            const textarea = document.createElement('textarea')
            textarea.value = text
            textarea.style.position = 'fixed'
            textarea.style.left = '-9999px'
            document.body.appendChild(textarea)
            textarea.select()
            document.execCommand('copy')
            document.body.removeChild(textarea)
          }
          this.$message.success('已复制到剪贴板')
        } catch (err) {
          console.error('复制失败:', err)
          this.$message.error('复制失败，请手动复制')
        }
      },
      confirmAction(row, type) {
        this.$refs.invoiceAction.open(row.batchNumber, type)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .container-box {
    margin: 12px 0 30px 0;
    padding: 0 10px;
  }

  .text-ellipsis-2 {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-all;
    line-height: 1.5;
    max-height: 3em;
  }

  .copyable {
    cursor: pointer;
    transition: color 0.3s;
  }

  .copyable:hover {
    color: #409eff;
    text-decoration: underline;
  }
</style>
